// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codegen-container {
    font-family: Arial, sans-serif;
    margin: 20px;
    padding: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #f9f9f9;
}

.input-section {
    text-align: center;
    margin-bottom: 20px;
}

.user-input {
    width: 80%;
    height: 100px;
    padding: 10px;
    font-size: 16px;
    resize: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.submit-button {
    display: block;
    width: 100%;
    margin-top: 10px;
    padding: 10px;
    background: #0056b3;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.submit-button:hover {
    background-color: #005bb5c7;
}

.interaction-section {
    margin-top: 20px;
}

.interaction-list {
    list-style-type: none;
    padding: 0;
}

.interaction-item {
    background-color: #f9f9f9;
    margin-bottom: 10px;
    padding: 15px;
    border-radius: 4px;
    border-left: 4px solid #007bff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.interaction-item strong {
    display: block;
    margin-bottom: 5px;
    font-size: 18px;
}

.interaction-item pre {
    background-color: #eef;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
}

.error-text {
    color: red;
    font-weight: bold;
    text-align: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rotating-progress-icon {
  animation: spin 1s linear infinite;
}
.icon-small-adjusted {
  font-size: 14px !important;
  position: relative;
  top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/codegen/CodegenAssistant.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;AACV","sourcesContent":[".codegen-container {\n    font-family: Arial, sans-serif;\n    margin: 20px;\n    padding: 20px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n}\n\n.input-section {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.user-input {\n    width: 80%;\n    height: 100px;\n    padding: 10px;\n    font-size: 16px;\n    resize: none;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.submit-button {\n    display: block;\n    width: 100%;\n    margin-top: 10px;\n    padding: 10px;\n    background: #0056b3;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.submit-button:hover {\n    background-color: #005bb5c7;\n}\n\n.interaction-section {\n    margin-top: 20px;\n}\n\n.interaction-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.interaction-item {\n    background-color: #f9f9f9;\n    margin-bottom: 10px;\n    padding: 15px;\n    border-radius: 4px;\n    border-left: 4px solid #007bff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.interaction-item strong {\n    display: block;\n    margin-bottom: 5px;\n    font-size: 18px;\n}\n\n.interaction-item pre {\n    background-color: #eef;\n    padding: 10px;\n    border-radius: 4px;\n    overflow-x: auto;\n}\n\n.error-text {\n    color: red;\n    font-weight: bold;\n    text-align: center;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.rotating-progress-icon {\n  animation: spin 1s linear infinite;\n}\n.icon-small-adjusted {\n  font-size: 14px !important;\n  position: relative;\n  top: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
